export default {
      id: "ic_close_comment-usage",
      viewBox: "0 0 22 17",
      url: "/" + "images/icons.3.109.2.svg#ic_close_comment-usage",
      toString: function () {
        return this.url;
      }
    }